import React from 'react';
import { Phone, Mail, MapPin, Clock, MessageSquare } from 'lucide-react';
import { Button } from '../components/ui/button';
import { businessInfo } from '../data/mock';
import QuoteForm from '../components/QuoteForm';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      {/* Hero */}
      <section className="pt-32 pb-12 bg-gradient-to-r from-blue-900 to-blue-800">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Contact Us
            </h1>
            <p className="text-xl text-blue-100">
              Get in touch for a free quote or to schedule service
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {/* Phone */}
            <div className="bg-white rounded-2xl p-8 shadow-lg text-center hover:shadow-xl transition-all">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Phone size={32} className="text-green-700" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Phone</h3>
              <a href={`tel:${businessInfo.phone}`} className="text-2xl font-bold text-blue-800 hover:text-blue-900">
                {businessInfo.phone}
              </a>
            </div>

            {/* Email */}
            <div className="bg-white rounded-2xl p-8 shadow-lg text-center hover:shadow-xl transition-all">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Mail size={32} className="text-blue-700" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Email</h3>
              <a href={`mailto:${businessInfo.email}`} className="text-lg text-blue-800 hover:text-blue-900 break-all">
                {businessInfo.email}
              </a>
            </div>

            {/* Address */}
            <div className="bg-white rounded-2xl p-8 shadow-lg text-center hover:shadow-xl transition-all">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <MapPin size={32} className="text-purple-700" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Address</h3>
              <p className="text-gray-700 font-semibold">{businessInfo.address}</p>
              <p className="text-sm text-gray-600 mt-1">{businessInfo.serviceArea}</p>
            </div>

            {/* Hours */}
            <div className="bg-white rounded-2xl p-8 shadow-lg text-center hover:shadow-xl transition-all">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Clock size={32} className="text-green-700" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Availability</h3>
              <p className="text-lg font-bold text-green-700">{businessInfo.availability}</p>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">How Can We Help You?</h2>
            <div className="flex flex-wrap justify-center gap-4">
              <Button 
                onClick={() => window.location.href = `tel:${businessInfo.phone}`}
                size="lg"
                className="bg-green-600 hover:bg-green-700 text-white font-bold px-8 py-6 text-lg"
              >
                <Phone size={24} className="mr-2" />
                Call for Emergency
              </Button>
              <Button 
                onClick={() => window.location.href = '/emergency'}
                size="lg"
                variant="outline"
                className="border-2 border-blue-800 text-blue-800 hover:bg-blue-800 hover:text-white font-bold px-8 py-6 text-lg"
              >
                <MessageSquare size={24} className="mr-2" />
                24/7 Emergency Service
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Form */}
      <QuoteForm />
    </div>
  );
};

export default ContactPage;